"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noAssetData = void 0;
var noAssetData = "No Asset Data was found! This may happen when accessing asset data before fetching from API.";
exports.noAssetData = noAssetData;